// Import necessary components and utilities
import { Badge, Text } from '@chakra-ui/react'; // Chakra UI components for styling
import { format, parseJSON } from 'date-fns'; // Utility functions for date formatting
import { resultTextColors } from 'utils/constants/result';

export const getResultTextColor = (result) => {
  return resultTextColors[result] || resultTextColors.Default;
};

// Define the columns for the session reports table
export default [
  {
    // Column for displaying the date the session was finished
    name: 'Date Finished',
    selector: (row) => row.dateFinished, // Access the 'dateFinished' field from the row
    sortable: true, // Enable sorting for this column
    cell: (row) => (
      <Text fontWeight={500} as="i">
        {row.dateFinished
          ? format(parseJSON(row.dateFinished), 'MMMM d, yyyy (h:mm a)') // Format the date if available
          : 'Pending'}
      </Text>
    ),
  },
  {
    // Column for displaying the score
    name: 'Score',
    selector: (row) => row.score, // Access the 'score' field from the row
    sortable: true, // Enable sorting for this column
    cell: (row) => (
      <Text fontWeight={500} as="i">
        {row.score ? parseFloat(row.score.toFixed(2)) : 0}
      </Text>
    ),
  },
  {
    // Column for displaying the result (Pass/Fail)
    name: 'Result',
    selector: (row) => row.result, // Access the 'result' field from the row
    sortable: true, // Enable sorting for this column
    cell: (row) => (
      <Text>
        {row.result ? (
          <Badge colorScheme={getResultTextColor(row.result)}>
            {row.result} {/* Display the result */}
          </Badge>
        ) : (
          <Badge colorScheme="blue">Pending</Badge> // Display 'Pending' if no result is available
        )}
      </Text>
    ),
  },
];
